// src/hooks/useDevice.js
import { useContext } from 'react';
import { DeviceContext } from '../context/DeviceContext';

const useDevice = () => {
    return useContext(DeviceContext);
};

export default useDevice;